import { OSS_URL } from '../../../config'
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    show: {
      type: Boolean,
      value: false
    },
    errPic: {
      type: String,
      value: ''
    },
    tips: {
      type: String,
      value: '很抱歉，该二维码暂未激活'
    },
    isShowBtn: {
      type: Boolean,
      value: true
    },
    btnText: {
      type: String,
      value: '立即返回'
    },
    themeColor: {
      type: String,
      value: '#32A0FA'
    }
  },
  /**
   * 组件的初始数据
   */
  data: {
    OSS_URL
  },

  /**
   * 组件的方法列表
   */
  methods: {
    /**
     * @param {Event} e
     */
    handleBtnTap (e) {
      this.triggerEvent('click', e)
    }
  }
})
